<!--
    描述：图标管理页面
    时间：2020-04-20
    Created by ws
-->
<template>
	<div class="w-page-main">
		<div class="w-page-header">
			<div class="btnGroups">
				<search-area v-model="searchName"
							 :showMore="false"
							 :showRefresh="false"
							 placeholderName="图标英文名称进行搜索"
							 @on-search="onSearch"></search-area>
			</div>
		</div>

		<div class="w-page-container overflow-y">
			<div class="icon-container">
				<div class="icon-item"
					 v-for="(item, index) in bindList"
					 :key="index">
					<svg-icon class="list-icon"
							  :icon-class="item.name ? item.name : ''"></svg-icon>
					<span class="list-title"
						  :class="{'active-title': item.name === searchName || item.highlight}">{{ item.name }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import searchArea from '@/components/searchArea/searchArea'
export default {
	components: {
		searchArea
	},
	data() {
		return {
			bindList: [], // 可操作属性的 菜单数组
			searchName: ''
		}
	},
	methods: {
		// 点击查询图标名称 高亮
		onSearch() {
			this.bindList.map((x) => {
				x.highlight = false

				if (x.name.indexOf(this.searchName) > -1) {
					x.highlight = true
				}
			})
		}
	},
	created() {
		this.bindList = this.filelist
	},
	computed: {
		// icon 目录下所有的 图表列表
		filelist() {
			const modulesFiles = require.context('@/icons/svg', true, /\.svg$/)

			let fileslist = []
			modulesFiles.keys().reduce((modules, modulePath) => {
				let _str = modulePath.replace('.svg', '')
				let _name = _str.substring(2)

				let obj = {
					name: _name,
					highlight: false
				}
				fileslist.push(obj)
			}, {})

			return fileslist
		}
	},
	watch: {
		// 监听searchName
		searchName(val) {
			if (val === '') {
				this.bindList.map((x) => (x.highlight = false))
			}
		}
	}
}
</script>

<style scoped lang="less">
.icon-container {
	display: flex;
	flex-wrap: wrap;

	.icon-item {
		width: 110px;
		height: 90px;
		display: flex;
		flex-direction: column;
		align-items: center;

		.list-icon {
			height: 50px;
			width: 50px;
			padding: 10px;
		}

		.list-title {
			height: 30px;
			line-height: 30px;
			font-size: 13px;
			text-align: center;
		}

		.active-title {
			color: #e80000;
			font-weight: 700;
			font-size: 16px;
		}
	}
}
</style>
